export const createHeaders = () => {
  return [
    // {
    //   name: "#",
    //   field: "serialNo",
    //   type: "text",
    //   headerTooltip: 'Line Item Number',
    //   width: 40,
    //   minWidth: 20,
    //   hide:false
    // },
    {
      name: "Claim",
      field: "isClaimed",
      type: "icon",
      headerTooltip: 'Claimed',
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'icon-align fa fa-anchor green-color-icon'
      // Claimed
    },
    {
      name: 'Unclaim',
      field: 'isUnClaimed',
      type: 'multi',
      headerTooltip: 'UnClaim',
      width: 35,
      minWidth: 40,
      maxWidth: 150,
      hide: false,
      icon: ' icon-align fa fa-remove orange-icon'
      // Claimed
    },
    {
      name: "GPS",
      field: "gpsTrackingStatus",
      type: "icon",
      filter: false,
      width: 35,
      minWidth: 35,
      maxWidth: 150,
      hide: false,
      headerTooltip: 'GPS',
      icon: 'icon-align fa fa-map-marker green-icon'
    },
    {
      name: "Checkin",
      field: "isCheckedIn",
      type: "icon",
      filter: false,
      sort: false,
      headerTooltip: "Checked In",
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa-sign-in green-icon'
    },
    {
      name: 'Break Time',
      field: 'breakTimeFlash',
      type: 'icon',
      filter: false,
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      headerTooltip: 'Break Time',
      icon: 'icon-align fa fa-pause-circle-o green-icon'
    },
    {
      name: "Checkout",
      field: "isCheckedOut",
      type: "icon",
      filter: false,
      sort: false,
      headerTooltip: "Checked out",
      width: 40,
      minWidth: 60,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa-sign-out fa-flip-horizontal green-icon'
    },
    {
      name: "Shift title",
      field: "jobTitle",
      type: "text",
      sort: false,
      width: 100,
      minWidth: 210,
      hide: false,
    },

    {
      name: "Shift Date",
      field: "currentMultiShiftJobDateToDisplay",
      type: "text",
      sort: false,
      minWidth: 160,
      width: 160,
      hide: false,
    },
    {
      name: "Appointment Type",
      field: "appointmentType",
      type: "text",
      filter: false,
      sort: false,
      width: 150,
      minWidth: 150,
      maxWidth: 250,
      hide: false,
    },
    {
      name: "Patient Name",
      field: "patientName",
      type: "text",
      filter: false,
      sort: false,
      width: 150,
      minWidth: 150,
      maxWidth: 250,
      hide: false,
    },
    {
      name: "Patient Address",
      field: "patientStreetAddress",
      type: "text",
      filter: false,
      sort: false,
      width: 300,
      minWidth: 300,
      maxWidth: 450,
      hide: false,
    },
    {
      name: "Shift Length",
      field: "shiftLengthDetails",
      type: "text",
      filter: false,
      sort: false,
      width: 100,
      minWidth: 100,
      maxWidth: 200,
      hide: false,
    },
    {
      name: "Start",
      field: "shiftStartTime",
      type: "text",
      sort: false,
      headerTooltip: "Start Time",
      width: 70,
      minWidth: 60,
      hide: false,
    },
    {
      name: "End",
      field: "shiftEndTime",
      type: "text",
      sort: false,
      width: 70,
      minWidth: 60,
      headerTooltip: 'End Time',
      hide: false,
    },
    {
      name: "EX/IN",
      field: "inExAuthorizedStatus",
      type: "text",
      filter: false,
      sort: false,
      width: 50,
      minWidth: 30,
      maxWidth: 150,
      hide: false,
    },
    {
      name: "Name",
      field: "name",
      type: "text",
      filter: false,
      sort: false,
      width: 70,
      minWidth: 100,
      hide: false,
    },
    {
      name: 'Mentor',
      field: 'isMentor',
      type: 'text',
      filter: false,
      sort: false,
      headerTooltip: 'Mentor',
      maxWidth: 35,
      width:35,
      hide: false,
    },
    {
      name: "Favorite",
      field: "isFavorite",
      type: "text",
      sort: false,
      headerTooltip: 'Favorite',
      width: 40,
      minWidth: 50,
      maxWidth: 150,
      hide: false,
      icon: 'fa icon-align fa fa-star green-icon'
    },
    {
      name: "Ratings",
      field: "ratings",
      type: "ratings",
      width: 75,
      minWidth: 85,
      hide: false,
    },
    {
      name: "Approval",
      field: "jobApproversList",
      type: "icon",
      filter: false,
      sort: false,
      headerTooltip: "Approval",
      minWidth: 90,
      hide: false,
    },
    {
      name: "Paid",
      field: "isPaid",
      type: "icon",
      filter: false,
      sort: false,
      width: 45,
      minWidth: 45,
      maxWidth: 150,
      hide: false,
    },
    {
      name: "Action",
      field: "action",
      type: "icon",
      filter: false,
      width: 85,
      minWidth: 110,
      hide: false,
    },
  ];
};
